import { render, staticRenderFns } from "./UnionDetails.vue?vue&type=template&id=a4e9a5ea&scoped=true"
import script from "./UnionDetails.vue?vue&type=script&lang=js"
export * from "./UnionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e9a5ea",
  null
  
)

export default component.exports